import React from 'react'
import { Switch, Route } from 'react-router-dom'

import CheckToggle from '../../common/components/CheckToggle'
import Checkbox from '../../common/components/Checkbox'

import { useUserPreferences } from '../hooks'

import { PREFERENCES } from '../constants'

const UserSettings = () => {
  const [
    preferences,
    {
      setIncidentDisplayOrder,
      setSigEventDisplayOrder,
      setTimestampFormat,
      setDefaultBasemap,
      setTraffic,
      setShowClosedSigEvents,
    },
  ] = useUserPreferences()

  return (
    <div>
      <Switch>
        <Route path="/sigevents">
          <CheckToggle
            title="Display Sig Events"
            options={[
              { label: 'By Modified', value: 'modified' },
              { label: 'By Created', value: 'created' },
            ]}
            onChange={setSigEventDisplayOrder}
            value={
              preferences[PREFERENCES.SIGEVENT_DISPLAY_ORDER] || 'modified'
            }
          />
        </Route>
        <Route path="/roadClosures"></Route>
        <Route path="/">
          <CheckToggle
            title="Display Incidents"
            options={[
              { label: 'My Location', value: 'location' },
              { label: 'Chronological', value: 'time' },
            ]}
            onChange={setIncidentDisplayOrder}
            value={preferences[PREFERENCES.INCIDENT_DISPLAY_ORDER] || 'time'}
          />
        </Route>
      </Switch>
      <CheckToggle
        title="Timestamps"
        options={[
          { label: 'Relative', value: 'relative' },
          { label: 'Exact', value: 'exact' },
        ]}
        onChange={setTimestampFormat}
        value={preferences[PREFERENCES.TIMESTAMP_FORMAT] || 'exact'}
      />
      <CheckToggle
        title="Basemap"
        options={[
          { label: 'Streets', value: 'streets-vector' },
          { label: 'Aerials', value: 'satellite' },
        ]}
        onChange={setDefaultBasemap}
        value={preferences[PREFERENCES.DEFAULT_BASEMAP] || 'streets-vector'}
      />
      <Switch>
        <Route path="/sigevents">
          <Checkbox
            title="Event History"
            label="Display Closed Events"
            checked={preferences[PREFERENCES.SHOW_CLOSED_SIGEVENTS]}
            onChange={setShowClosedSigEvents}
          />
        </Route>
        <Route path="/roadClosures"></Route>
        <Route path="/">
          <Checkbox
            title="Traffic"
            label="Display traffic conditions"
            checked={preferences[PREFERENCES.SHOW_TRAFFIC]}
            onChange={setTraffic}
          />
        </Route>
      </Switch>
    </div>
  )
}

export default UserSettings
